import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { ILab } from '../../app/models/labs/lab';
import { environment } from '@env/environment';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
  }),
  withCredentials: true
};

@Injectable({
  providedIn: 'root',
})
export class LabService {
  constructor(private toastr: ToastrService, private http?: HttpClient) {}

  getLabs(): Observable<ILab[]> {
    return this.http.get<ILab[]>(environment.privateApi + 'Labs/All', { withCredentials: true });
  }

  getLab(labDetailsId: number): Observable<ILab> {
    return this.http.get<ILab>(environment.privateApi + 'Labs/Edit/' + labDetailsId, { withCredentials: true });
  }

  deleteLab(id: number): Observable<any> {
    return this.http.get(environment.privateApi + 'Labs/Delete/' + id, httpOptions);
  }

  saveLab(lab: ILab): Observable<any> {
    return this.http.post(environment.privateApi + 'Labs/SaveLab', lab, httpOptions);
  }
}